import { render } from "./PreLoader.vue?vue&type=template&id=3cb12079&scoped=true&ts=true"
import script from "./PreLoader.vue?vue&type=script&lang=ts"
export * from "./PreLoader.vue?vue&type=script&lang=ts"

import "./PreLoader.vue?vue&type=style&index=0&id=3cb12079&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb12079"]])

export default __exports__